import React from 'react'

import { Field } from 'formik'

import { Col, Row, Form } from '_zari/core'

const FlagCentroCostoFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Row>
      <Col md={4} />
      <Col md={8}>
        <Field name='flagCentroCosto'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagCentroCosto'
              label='Centro Costo'
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(FlagCentroCostoFormGroup)
